var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0.791687V2.37502H1.95833C1.07958 2.37502 0.375 3.0796 0.375 3.95835V15.0417C0.375 15.9125 1.07958 16.625 1.95833 16.625H6.7875C7.785 17.6067 9.15458 18.2084 10.6667 18.2084C13.7304 18.2084 16.2083 15.7304 16.2083 12.6667C16.2083 11.1546 15.6067 9.78502 14.625 8.78752V3.95835C14.625 3.08752 13.9204 2.37502 13.0417 2.37502H12.25V0.791687H10.6667V2.37502H4.33333V0.791687H2.75ZM1.95833 3.95835H13.0417V5.54169H1.95833V3.95835ZM1.95833 7.12502H13.0417V7.65544C12.3212 7.31502 11.5138 7.12502 10.6667 7.12502C7.60292 7.12502 5.125 9.60294 5.125 12.6667C5.125 13.5138 5.315 14.3213 5.65542 15.0417H1.95833V7.12502ZM10.6667 8.8271C12.7883 8.8271 14.5063 10.545 14.5063 12.6667C14.5063 14.7884 12.7883 16.5063 10.6667 16.5063C8.545 16.5063 6.82708 14.7884 6.82708 12.6667C6.82708 10.545 8.545 8.8271 10.6667 8.8271ZM9.875 10.2917V13.2129L12.4004 14.6696L12.9942 13.6404L11.0625 12.5242V10.2917H9.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkWizardIcon);
export default __webpack_public_path__ + "static/media/work-wizard-icon.3bb62569.svg";
export { ForwardRef as ReactComponent };